// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"appdashboard_groupTitle__y2OaU","apps":"appdashboard_apps__jJsH0"};